// Browsers serialize header values as Latin-1, but the server reads the
// impersonate header as UTF-8, so account names with non-ASCII characters
// (e.g. diacritics) get mangled. Send the raw UTF-8 bytes instead.
export function impersonateHeaderValue(account: string | undefined): string {
  return Array.from(new TextEncoder().encode(`"${account}"`), (byte) =>
    String.fromCharCode(byte)
  ).join('')
}
